module.exports = __webpack_public_path__ + "9bbb7e4d943a3d7ce70c8026b4b7595a.svg";